export const API_ROOT = 'https://apidev.zizbeyjobs.com'
// export const API_ROOT = 'http://10.0.0.36:8559/'

//Staging url ==> https://sadev.zizbeyjobs.com